import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  variant: {
    type: 'string',
    default: 'default',
  },
  sideImage: {
    type: 'object',
    default: {
      id: '',
      src: '/wp-content/uploads/2022/11/people-leisure-pastime-concept-overjoyed-unshaven-adult-man-sits-lotus-poses-sofa-holds-remote-control-watches-funny-show-television.webp',
      alt: '',
    },
  },
  plansName: {
    type: 'string',
    default: 'directvgo',
  },
  ...Common,
};
